// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniMenu_container__VT9BN","menu":"MiniMenu_menu__9AxxS","menuItem":"MiniMenu_menuItem__mD5Z4","menuRightAlign":"MiniMenu_menuRightAlign__Edtjt"};